import { useState } from "react";
import { FileUpload } from "primereact/fileupload";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import useAxiosPrivate from "../hooks/useAxiosPrivate";

const PagosMasivos = () => {
  const axiosPrivate = useAxiosPrivate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔥 subir archivo
  const handleUpload = async ({ files }) => {
    const file = files[0];

    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoading(true);

      const res = await axiosPrivate.post(
        "CEUM/pagos/preview",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" }
        }
      );

      setData(res.data);

    } catch (e) {
      console.error(e);
      alert("Error al procesar archivo");
    } finally {
      setLoading(false);
    }
  };

  // 🔥 aplicar pagos
  const aplicar = async () => {
    try {
      await axiosPrivate.post("CEUM/pagos/masivo", {
        items: data.filter(d => d.valido)
      });

      alert("Pagos aplicados");
      setData([]);

    } catch (e) {
      console.error(e);
    }
  };

  const statusBody = (row) => (
    <span style={{ color: row.valido ? "green" : "red" }}>
      {row.valido ? "✔" : "✖"}
    </span>
  );

  return (
    <>
      <FileUpload
        name="file"
        accept=".xlsx,.csv"
        customUpload
        uploadHandler={handleUpload}
        chooseLabel="Cargar archivo banco"
      />

      <DataTable value={data} loading={loading} className="mt-3">
        <Column field="matricula" header="Matrícula" />
        <Column field="monto" header="Monto" />
        <Column field="fecha" header="Fecha" />
        <Column header="Estado" body={statusBody} />
        <Column field="mensaje" header="Detalle" />
      </DataTable>

      {data.length > 0 && (
        <div className="flex justify-content-end mt-3">
          <Button
            label="Aplicar pagos"
            icon="pi pi-check"
            onClick={aplicar}
          />
        </div>
      )}
    </>
  );
};

export default PagosMasivos;